<section class="section-bottom-hero" *ngIf="heroData">
  <div class="section-bottom-container">
    <div class="product-bottom-content-box justfy-item-e">
      <div class="product-bottom-content">
        <h1 class="product-hero-header">
          {{ heroData?.header }}
        </h1>
        <div class="landing-btn mar-t-48 align-c">
          <button class="btn btn-full" (click)="scrollTo()">
            {{ heroData.button.text }}
          </button>
        </div>
      </div>
      <img src="{{ heroData.image.url }}" alt="{{ heroData.image.alt }}" />
    </div>
  </div>
</section>
